/**
 * Seed zone for `schedulingInitialState` — the value the board holds for the few
 * frames between store construction and the first `initial-scheduling-data`
 * payload landing. Its only consumers are `selectedDate` and `timezone` in
 * `schedulingInitialState` (./types.ts).
 *
 * It is NOT a fallback for a payload zone, and must never be reintroduced as one.
 * The board's real zone is the MARKET's, and the backend always sends it:
 * `InitialSchedulingDataPresenter.php:28` types the horizon
 * `array{start: CarbonInterface, days: int, timezone: string}` — non-nullable —
 * and `:72` emits it; `IntelligentRoutingController.php:143` assigns it
 * unconditionally from the market. The org-wide default that fills in for a
 * market with no zone is BE-owned, in one configurable place:
 * `config/settings.php` `settings.default_timezone` (`'America/Chicago'`).
 * Verified against `lula-foresight-be` origin/main at v2.76.0.
 *
 * Keep the value a real US market zone. Two alternatives were evaluated and
 * refuted: `null`/`''` makes `fmtInZone` return `''` for every field
 * (normalizer.ts `fmtInZone` → `utcToZoned` short-circuits on an invalid zone)
 * and makes `resolveDisplayTimezone` print the VIEWER's zone on the board;
 * `'UTC'` is a valid IANA name, so nothing warns, and it is wrong for every US
 * market.
 */
export const SCHEDULING_BOOTSTRAP_TIMEZONE = 'America/Chicago';
